import {
  AfterViewInit,
  Component, OnDestroy,
  OnInit,
} from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {BehaviorSubject, Subject, Subscription} from 'rxjs';
import {DialogModel} from '@shared/models/dialog.model';
import {IMenuItem} from '@shared/interfaces/menu-item.interface';
import {select, Store} from '@ngrx/store';
import {TaskManagerState} from '@features/task-manager/store/task-manager.reducer';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {SnackBarService} from '@core/services/snack-bar.service';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {skip, take, takeUntil} from 'rxjs/operators';
import {QueryProvider} from '@shared/queries/query-provider';
import {TaskManagerConfig} from '@features/task-manager/helpers/task-manager.config';
import {TaskManagerQuery} from '@features/task-manager/helpers/task-manager.query';
import {GraphQLService} from '@core/services/graphql.service';
import {TaskManagerService} from '@features/task-manager/services/task-manager.service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {Location} from '@angular/common';
import {Guid} from 'guid-typescript';
import {GetSelectedTaskAction, SetTaskViewUpdateInfoAction} from '@features/task-manager/store/task-manager.action';
import { FileModel } from '@shared/models/file-model';
import { StringUtility } from '@shared/utility/string-utility';
import { getFileModel } from '@shared/store/selectors/file-store.selector';
import { UploadFilePresignedAction } from '@shared/store/actions/file-store.actions';
import { Attachment, FileData, UploadFileStructure } from '@features/task-manager/models/task-manager.model';
import { PlatformQueryService } from '@core/services/platform-query.service';
import { PlatformQuery } from '@shared/models/platform-query/platform-query';
import { Api } from '@shared/constants/common-field.constants';
import {ActivatedRoute, Router} from '@angular/router';
import { getBoardForSelectedTaskById, getSelectedTaskById } from '@features/task-manager/store/task-manager.selector';
import { ContentScope } from '@shared/commands/command-base';
import {CollaborationState} from '@features/task-manager/collaboration/store/collaboration.reducer';
import {CreateChatConversationCommand} from '@features/task-manager/collaboration/store/collaboration.command';
import {CreateChatConversationAction} from '@features/task-manager/collaboration/store/collaboration.action';
import {ConversationComponentName, ConversationListComponentName} from '@features/task-manager/collaboration/store/collaboration.constants';
import { UserModel } from '@shared/models/user.model';
import {getUserInfo} from '@shared/store/selectors/security.selector';
import {SecurityState} from '@shared/store/reducers/security.reducer';
import {SetCurrentRightSideComponentAction} from '@shared/components/platform-sidebar/store/platform-sidebar.action';
import {PlatformSidebarState} from '@shared/components/platform-sidebar/store/platform-sidebar.reducer';




@Component({
    standalone: false,
    selector: 'particle-task',
  templateUrl: './task.component.html',
  styleUrls: ['./task.component.scss']
})
export class TaskComponent implements OnInit, IDialogView, AfterViewInit, OnDestroy {
  // body is changeable. component will change its look based on selected menu
  // main component which will contain toolbar, body, details on right bar.

  data: DialogModel;
  isReady = false;

  defaultMainViewDetails: any;
  selectedMainViewDetails: any;
  selectedMainViewDetails$: BehaviorSubject<IMenuItem> = new BehaviorSubject<IMenuItem>(null);
  taskMenuItemsMapper: any = {};
  taskDialogMenuItems: IMenuItem[];
  unSubscribe = new Subject<void>();

  fileOver: boolean;
  scope: number;
  type: string;
  private selectedDataSubscription: Subscription;
  private onEnterCounter = 0; //keeping this to ignore child component onLeave event trigger(flickkering on fileOver issue)

  selectedData$: BehaviorSubject<UploadFileStructure[]> = new BehaviorSubject(null);
  uploadFilesData: FileData[] = [];
  selectedItem: UploadFileStructure[] | null = [];
  //same file multiple attachments
  cardId: string;
  alreadyAttached: Attachment[] = [];
  private attachmentsInfoLoaded = new Subject<void>();
  currentBoard: any;
  currentTask: any;
  ticketId: string;
  isSupport = false;
  isSupportMember = false;
  currentUser: UserModel;



  constructor(private taskManagerStore: Store<TaskManagerState>,
              private platformSidebarStore: Store<PlatformSidebarState>,
              private taskManagerService: TaskManagerService,
              private location: Location,
              private queryStore: Store<IQueryState>,
              private graphQLService: GraphQLService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private snackBarService: SnackBarService,
              private store: Store<IQueryState>,
              private platformQueryService: PlatformQueryService,
              private activatedRoute: ActivatedRoute,
              private collaborationStore: Store<CollaborationState>,
              private securityStore: Store<SecurityState>,
              private router: Router
  ) {
    this.defaultMainViewDetails = {
      'editor': 'TaskBodyDefaultViewComponent'
    };
    this.selectedMainViewDetails = JSON.parse(JSON.stringify(this.defaultMainViewDetails));
  }

  ngOnInit(): void {
    this.ticketId = this.activatedRoute.snapshot.paramMap.get('taskId');

    if(!this.data) {
      this.isSupport = true;
      this.securityStore.select(getUserInfo).pipe(takeUntil(this.unSubscribe)).subscribe(currentUser => {
        this.currentUser = currentUser;
        this.isSupportMember = this.currentUser.companyId === 'orbitaxsupport';
        if (this.isSupportMember) {
          this.onBeforeInitializeData();
        } else {
          this.router.navigateByUrl('');
        }
      });
    } else {
      this.setUpInitializers();
    }
  }

  private onBeforeInitializeData() {
    this.taskManagerStore.dispatch(new GetSelectedTaskAction('TaskManagerApi',
      TaskManagerQuery.getSelectedTask(this.ticketId, "ORBITAX_SUPPORT", true), this.ticketId));

    const unsubscribeTaskInfo = new Subject<void>();
    this.taskManagerStore.pipe(select(getSelectedTaskById)).pipe(takeUntil(unsubscribeTaskInfo)).subscribe(task => {
      this.currentTask = task;
      this.initializeData(unsubscribeTaskInfo);
    });
    this.taskManagerStore.pipe(select(getBoardForSelectedTaskById)).pipe(takeUntil(unsubscribeTaskInfo)).subscribe(board => {
      this.currentBoard = board;
      this.initializeData(unsubscribeTaskInfo);
    });
  }
  private setUpInitializers() {
    this.setupInvalidators();
    this.setToolbarNavigationSystem(this.data.input.card);
    this.selectedDataSubscription = this.selectedData$.subscribe(selectedDataChange => {
      //sending selected item to task-attachment-component through data.input
      this.data.input = { ...this.data.input, isDirectUpload: true, selectedItem: selectedDataChange }
    })
    this.cardId = this.data.input.card["id"];
    this.scope = this.data.input.card["scopeInt"];
  }

  ngAfterViewInit(): void {
    if(this.data) {
      this.afterViewInitTask();
    }
  }

  private afterViewInitTask() {
    this.queryStore.pipe(select(getQueryResponse, 'taskDialogMenu')).pipe(skip(1), take(1)).subscribe(filter => {
      if (filter && filter.taskDialogMenu) {
        this.taskDialogMenuItems = filter.taskDialogMenu;
        this.setUpTaskMenuItemsMapper(filter.taskDialogMenu);
        this.setViews(true);
        if (this.data.input.selectedMenuDetail) {
          this.selectedMainViewDetails = filter.taskDialogMenu.find(menu => menu.id === this.data.input.selectedMenuDetail.id);
        }
        this.selectedMainViewDetails$.next(this.selectedMainViewDetails);
      }
    });
    if (this.data.input.parameters?.taskApi) {
      const queryModel = this.taskManagerService.getQueryModel('taskDialogMenu');
      queryModel.api = this.data.input.parameters.taskApi;
      QueryProvider.postQuery(queryModel, {'[TEMPLATE]': this.data.input.template}, this.queryStore);
    }
    else {
      QueryProvider.invokeQuery(this.queryStore, 'taskDialogMenu', {'[TEMPLATE]': this.data.input.template});
    }
  }
  private getConversationSourceInfoDictionary() {
    const sourceInfoDictionary = {
      'sourceInfoDictionary': {
        TicketDisplayId: this.currentTask?.displayId,
        TaskId: this.currentTask?.id,
        ConversationType: 'support-internal-chat'
      }
    };
    return sourceInfoDictionary;
  }

  private getConversationPeopleWithRole() {
    const rolesArray = [];
    this.currentTask.assignments.forEach(element => {
      const user = element.assignedTo as UserModel;
      if (user.companyId === 'orbitaxsupport') {
        rolesArray.push({'user': user, permissionType: 290, 'roleTypes': [1, 2, 3]});
      }
    });
    return rolesArray;
  }

  private openChatConversation() {
    const sourceInfoDictionary = this.getConversationSourceInfoDictionary();
    const rolesArray = this.getConversationPeopleWithRole();
    const createChatConversationCommand = new CreateChatConversationCommand(
      '[COMPANY_ID]-chat',
      `Ticket (${this.currentTask?.displayId}) - LiveChat`,
      true,
      0,
      'OrbitaxSupport',
      rolesArray,
      true,
      null,
      sourceInfoDictionary
    );
    createChatConversationCommand.scope = ContentScope.OrbitaxSupport;
    if (this.isSupportMember && this.isAllowCreateConversation(rolesArray)) {
      this.collaborationStore.dispatch(new CreateChatConversationAction(createChatConversationCommand, ConversationComponentName));
    }
  }
  private isAllowCreateConversation(rolesArray: any[]) {
    return rolesArray.length > 0 && rolesArray.findIndex(role =>
      role.user.email.toLowerCase() === this.currentUser.email.toLowerCase()) !== -1;
  }
  initializeData(unsubscribeTaskInfo: any) {
    if(this.currentBoard && this.currentTask) {
      unsubscribeTaskInfo.next(null);
      unsubscribeTaskInfo.complete();
      const dialogModelData = {
        board: this.currentBoard,
        card: this.currentTask,
        template: this.taskManagerService.getTaskEditTemplate(this.currentBoard),
        showVerticalMenu: true,
        parentUrl: ''
      };
      this.data = DialogModel.create(`Task > ${this.currentTask.displayId} - ${this.currentTask.title}`, 'TaskComponent', dialogModelData, '800px');
      this.setUpInitializers();
      this.afterViewInitTask();
      this.openChatConversation();
    }
  }

  private setUpTaskMenuItemsMapper(menus: IMenuItem[]) {
    this.taskMenuItemsMapper = {};
    this.taskMenuItemsMapper['defaultBodyView'] = {
      'editor': 'TaskBodyDefaultViewComponent'
    };
    if (menus && menus.length > 0) {
      menus.forEach(menu => {
        this.taskMenuItemsMapper[menu.id] = menu;
      });
    }
  }

  onOkClicked(): any {
  }

  onCloseClicked($event: any) {
    const dialogRef = this.data['dialogRef'];
    dialogRef.close({
      action: 'Closed',
      data: this.data
    });
  }

  getTask(card: any, mainViewDetails: any = null, refreshCurrentTaskViewPayload = null) {
    if (card && card.id) {
      if (!refreshCurrentTaskViewPayload) { // we want to replace current task otherwise just refresh current task
        this.fuseSplashScreenService.show();
      }
      let api = TaskManagerConfig.TaskManagerApiKey;
      if (this.data.input.parameters?.taskApi) {
        api = this.data.input.parameters.taskApi;
      }
      this.graphQLService.executePostRequest(api, TaskManagerQuery.getSelectedTask(card.id, card.scope)).pipe(take(1))
        .subscribe(payload => {
          this.fuseSplashScreenService.hide();
          if (payload && payload.data && payload.data.ticketWithBoard) {
            if (refreshCurrentTaskViewPayload) {
              this.invalidateCurrentTaskViews(payload.data.ticketWithBoard, refreshCurrentTaskViewPayload);
            } else {
              this.invalidateTask(payload.data.ticketWithBoard, mainViewDetails, true); // we are replacing current task
            }
          } else {
            this.snackBarService
              .showError('Note: This task is no longer available. Either because the task was completed/deleted, or you are no longer required to provide action on this task.');
          }
        });
    }
  }

  private resetCardDetails(card: any) {
    this.data.input.card = card;
  }

  private invalidateTask(card: any, mainViewDetails: any = null, setToolbarNavigation = false) {
    this.setViews(false);
    this.taskViewUpdateAction(null);
    setTimeout(() => {
      this.resetCardDetails(card);
      if (setToolbarNavigation) {
        this.setToolbarNavigationSystem(card);
      }
      this.resetUrl();
      this.setMainViewDetails(mainViewDetails);
      this.setViews(true);
    }, 200);
  }

  private resetUrl() {
    const parentUrl = this.data.input.parentUrl;
    if (parentUrl && parentUrl.length > 0) {
      const url = Location.joinWithSlash(parentUrl, this.data.input.card.id);
      if (url) {
        this.location.replaceState(url);
      }
    }
  }

  private setMainViewDetails(mainViewDetails: any) {
    if (mainViewDetails) {
      this.selectedMainViewDetails = mainViewDetails;
    } else { // get default main veiw
      this.selectedMainViewDetails = JSON.parse(JSON.stringify(this.defaultMainViewDetails));
    }
    this.selectedMainViewDetails$.next(this.selectedMainViewDetails);
  }

  ngOnDestroy(): void {
    if(this.selectedDataSubscription){
      this.selectedDataSubscription.unsubscribe();
    }
    this.unSubscribe.next();
    this.unSubscribe.complete();
    // this.taskManagerService.getSelectedBoard(this.data.input.board.id, this.data.input.board.scope);
    this.taskManagerStore.dispatch(new SetTaskViewUpdateInfoAction(null));
    if (this.isSupportMember) {
      this.platformSidebarStore.dispatch(new SetCurrentRightSideComponentAction({
        component: ConversationListComponentName,
        data: {},
        componentInfo: null
      }));
    }
  }



  onDragEnter(evt:DragEvent){
    // console.log("On Drag Enter")
    this.onEnterCounter++;
    // console.log("OnEnterCounter:=====", this.onEnterCounter);
  }

  onDragOver(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = true;
  }

  onDragLeave(evt: DragEvent){
    evt.preventDefault();
    evt.stopPropagation();
    this.onEnterCounter--;
    // console.log("OnEnterCounter:=====", this.onEnterCounter);
    if(this.onEnterCounter === 0){
      this.fileOver = false;
    }
  }

  onPaste(evt: ClipboardEvent) {
    // evt.preventDefault(); // could not paste text to texteditor issue fix second time(nebula did not get merge)
    // evt.stopPropagation();
    if (Array.from(evt.clipboardData.types).includes('Files')) {
      const files: File[] = Array.from(evt.clipboardData.files);
      this.directUploadFile(files);
    }
  }

  onDrop(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.fileOver = false;
    if(Array.from(evt.dataTransfer.types).includes('Files')){
      const files: File[] = Array.from(evt.dataTransfer.files);
      this.directUploadFile(files);
    }
  }



  directUploadFile(files: File[]) {
    if (this.exceedsMaxAttachmentSize(files)) {
      return;
    }
    this.getAttachmentsInfo();
    //getting the attachments of the task first to enable ITP2-1245
    this.attachmentsInfoLoaded.pipe(take(1)).subscribe(response => {
      this.setFileData(files);
      this.uploadFilesData.forEach(file => {
        this.upload(file);
      });
    })
  }

  private exceedsMaxAttachmentSize(files: File[]): boolean {
    const maxSize = TaskManagerConfig.maxAttachmentSizeInBytes;
    if (!maxSize || !files) {
      return false;
    }

    const oversized = Array.from(files).filter(file => file && file.size > maxSize);
    if (oversized.length === 0) {
      return false;
    }

    const limitInMb = Math.floor(maxSize / (1024 * 1024));
    const names = oversized.map(file => file.name).join(', ');
    this.snackBarService.showError(
      `${names} exceeds the ${limitInMb} MB attachment limit and was not uploaded.`);
    return true;
  }


  setFileData(files: File[]) {
    if (files.length < 0) {
      return;
    }
    files.forEach(file => {
      let fileData = this.getFileData(file, true);
      this.uploadFilesData.push(fileData);
    });    
  }

  private getFileData(file: File, unique: boolean = false): FileData {

    let fileData: FileData = {
      file,
      fileExtension:file.name.slice(file.name.lastIndexOf('.'), file.name.length),
      fileNameWithoutExtension:file.name.slice(0, file.name.lastIndexOf('.'))
    } 

    if(unique){
      fileData = this.getUniqueName(file);
    }
    return fileData;
  }

  private getUniqueName(file:File): FileData{
    let copyIndex = 1;
    let fileNameWithoutExtension = file.name.slice(0, file.name.lastIndexOf('.'));
    let fileExtension = file.name.slice(file.name.lastIndexOf('.'), file.name.length);
    let uniqueName = file.name;

    // Generate unique name
    while (this.alreadyAttached.some(f => f.title === uniqueName)) {
      if (copyIndex === 1) {
        uniqueName = `${fileNameWithoutExtension} - Copy${fileExtension}`;
      } else {
        uniqueName = `${file.name.slice(0, file.name.lastIndexOf('.'))} - Copy(${copyIndex})${fileExtension}`;
      }
      fileNameWithoutExtension = uniqueName.slice(0, uniqueName.lastIndexOf('.'));
      copyIndex++;

    }
    return {
      file: new File([file],uniqueName, {type: file.type}), //creating a new file blob with unique name
      fileNameWithoutExtension: fileNameWithoutExtension,
      fileExtension: fileExtension
    };
  }



  upload(fileData: FileData) {
    if (!fileData.file){
      this.setSelectedItemValue(null);
    }

    let directoryPath = this.data['rootFolderPath'] ? this.data['rootFolderPath'].value : 'Root';
    let key = this.data['rootFolderPath'] ? StringUtility.getFileNameExcludingExtension(fileData.file.name) : Guid.create().toString();

    const fileModel = FileModel.createClientFileModel(directoryPath, fileData.file, StringUtility.getFileNameExcludingExtension(fileData.file.name));
    const fileModel$ = this.store.pipe(select(getFileModel, key));

    fileModel$.pipe(takeUntil(this.unSubscribe)).subscribe(state => {
      if (state && state.fileId) {
        this.type = 'DirectoryEntries';
        this.setSelectedItemValue({
          id: state.fileId,
          cells: {
            Name: { displayText: fileData.file.name },
            IsFolder: { value: false }
          }
        });
        this.removeUploadFileData(state.fileName)
      }
    });

    this.store.dispatch(new UploadFilePresignedAction(key, fileData.file, fileModel, true));
  }

  removeUploadFileData(fileName: string) {
    const fileIndex = this.uploadFilesData.findIndex(fileData => fileData.file.name === fileName);
    if (fileIndex !== -1) {
      console.log(`Removing ${fileName}, index ${fileIndex}`);
      this.uploadFilesData.splice(fileIndex, 1);
      if(this.uploadFilesData.length == 0){
        this.publishData();
      }
    }
    console.log(this.uploadFilesData);
  }

  publishData() {
    this.selectedData$.next(this.selectedItem);
  }

  setSelectedItemValue(value: UploadFileStructure | null) {
    this.selectedItem.push(value);

  }

  handleActionEvent($event: { id: string, type: string, card: any, params?: any }) {
    switch ($event.type) {
      case 'OpenTask':
        const mainViewDetails = this.taskMenuItemsMapper.hasOwnProperty($event.id) ? JSON.parse(JSON.stringify(this.taskMenuItemsMapper[$event.id])) : null; // If any specific view given. load it. otherwise main view
        this.getTask($event.card, mainViewDetails);
        // this.setToolbarNavigationSystem($event.card);
        break;
      case 'OpenToolbarNavigationSubTask':
        const isSubTask = !!$event.card.parentTicket;
        let parentTicketId = $event.card.id; // parent ticket for current subtask
        if (isSubTask) { // if current task is a subtask then parent ticket will be its parent otherwise task id
          parentTicketId = $event.card.parentTicket.id;
        }
        this.getSubtasks(parentTicketId, $event.card.scope, $event.params.pageNo, $event.params.pageSize, '', true);
        break;
      case 'ClosedClick':
        this.onCloseClicked($event);
        break;
      case 'MainViewBodyChangeEvent':
        this.setMainViewDetails(this.taskMenuItemsMapper[$event.id]);
        break;
      case 'HomeClick':
        this.router.navigateByUrl('');
        break;
      case 'OpenChat':
        this.openChatConversation();
        break;
    }
  }

  private setToolbarNavigationSystem(card) {
    const isSubTask = !!card.parentTicket;
    console.log('[is subtask]:', isSubTask);
    if (!isSubTask) {
      // lets get subtask information for this task
      this.getSubtasks(card.id, card.scope, 0, 1, '');
    } else {
      // lets detect current subtask position
      this.getSubtasks(card.parentTicket.id, card.scope, 0, 1, card.id);
    }
  }

  getSubtasks(ticketId, scope, pageNo, pageSize, targetSubTaskId = '', openTask = false) {
    let isSubTask = !!targetSubTaskId;
    if (openTask) { // todo: shakil need to make this smart. note, since we only open subtask so this is subtask
      isSubTask = true;
    }
    if (ticketId) {
      let api = TaskManagerConfig.TaskManagerApiKey;
      if (this.data.input.parameters?.taskApi) {
        api = this.data.input.parameters.taskApi;
      }
      this.graphQLService.executePostRequest(api, TaskManagerQuery.getSubTasks(ticketId, scope, pageNo, pageSize, targetSubTaskId)).pipe(take(1))
        .subscribe(payload => {
          if (payload && payload.data && payload.data.subTickets) {
            const subTickets = payload.data.subTickets;
            if (openTask && subTickets.items && subTickets.items.length > 0) {
              this.invalidateTask(subTickets.items[0]);
            }
            this.setToolbarNavigationModel(isSubTask, subTickets.pageNo, subTickets.pageSize, subTickets.pageCount);
          }
        });
    }
  }

  private setToolbarNavigationModel(isPreviousTaskSubTask, pageNo, pageSize, pageCount) {
    this.data.input.toolbarSubTaskNavigation = {
      pageNo: isPreviousTaskSubTask ? pageNo : pageNo - 1,
      pageSize: pageSize,
      pageCount: pageCount
    };
  }

  private setViews(isReady: boolean) {
    this.isReady = isReady;
  }

  private setupInvalidators() {
    this.data.input.taskInvalidator = new Subject<void>();
    this.data.input.taskInvalidator.pipe(takeUntil(this.unSubscribe)).subscribe(invalidateCurrentTaskViewPayload => {
      const card = invalidateCurrentTaskViewPayload.card;
      // const sourceViewId = invalidateCurrentTaskViewPayload.sourceViewId;
      // const invalidateTaskToolbarNavigationSystem = invalidateCurrentTaskViewPayload.invalidateTaskToolbarNavigationSystem;
      if (card && card.id === this.data.input.card.id) { // refreshing view for real time update
        this.getTask(this.data.input.card, null, invalidateCurrentTaskViewPayload);
      } else {  // open the new task
        this.getTask(card);
      }
    });
  }

  private invalidateCurrentTaskViews(updatedCard: any, invalidatedCurrentTaskViewPayload: any) {
    this.resetCardDetails(updatedCard);
    if (invalidatedCurrentTaskViewPayload.invalidateTaskToolbarNavigationSystem) { // for add subtask and create or delete occurrances
      this.setToolbarNavigationSystem(updatedCard);
    }
    invalidatedCurrentTaskViewPayload.card = updatedCard;
    this.taskViewUpdateAction(invalidatedCurrentTaskViewPayload);
  }

  private taskViewUpdateAction(invalidatedCurrentTaskViewPayload: any) {
    this.taskManagerStore.dispatch(new SetTaskViewUpdateInfoAction(invalidatedCurrentTaskViewPayload));
  }
  getAttachmentsInfo() {
    let getTaskAttachmentsQuery = this.getTaskAttachementsQuery();
    this.platformQueryService.executeQuery(getTaskAttachmentsQuery).pipe(take(1)).subscribe(response => {
      if (response && response.fieldValues && response.fieldValues['Attachments']) {
        this.alreadyAttached = []; //reseting already attached file
        let currentAttachments = response.fieldValues['Attachments'];
        currentAttachments.forEach(element => {
           let attachment = element.fieldValues;
           attachment.id = element.id;

           //from different query(other in DialogDefinitionMultipleFileUploadEditorComponent) data comes in different case from backend
           let mapAttachment: Attachment = {
            displayTitle: attachment.DisplayTitle,
            icon: attachment.Icon,
            isFolder: attachment.IsFolder,
            title: attachment.Title,
            id: attachment.id,
            attachedBy: attachment.AttachedBy,
            attachedDate: attachment.AttachedDate
           }
           this.alreadyAttached.push(mapAttachment);
        });
        this.attachmentsInfoLoaded.next();
      }
    });
  }


  private getTaskAttachementsQuery() {
    let getTaskAttachementsQuery = new PlatformQuery();
    getTaskAttachementsQuery.api = Api.TaskManager;
    getTaskAttachementsQuery.name = 'TaskAttachmentsQuery';
    getTaskAttachementsQuery.fieldValues['TaskId'] = this.cardId;
    getTaskAttachementsQuery.fieldValues['Scope'] = this.scope;
    getTaskAttachementsQuery.isCamelCase = true;
    return getTaskAttachementsQuery;
  }
}
